import { defineMessages } from 'react-intl';

export default defineMessages({
    BR_PL_0110: {
        id: 'wni.br.pl.0110.Account with declined quotes in the last year selected.',
        defaultMessage: 'Account with declined quotes in the last year selected.'
    }
});
